<template>
  <div class="multi-section-wrap">
    <common-header
      title="LIVE"
      :is-back-btn="true"
      :back-fn="close"
      :is-close-btn="false"
      :go-to-schedule-fn="goToSchedule"
      :go-to-reserve-watch-fn="goToReserveWatch"
    />
    <WCatalog v-if="catalogData" :id="id" :catalog="catalogData" />
  </div>
</template>
<script>
  import { onDisplay } from '@/common/directives'
  import { enableBodyScroll } from '@/common/util/ui.utils'
  import CommonHeader from '@/components/header/template/commonHeader'
  import {
    PATH_NAME_RESERVE_WATCH,
    PATH_NAME_SCHEDULE,
  } from '@/common/router.const'
  import WCatalog from '@/views/home/WCatalog.vue'
  import { ref } from 'vue'
  import { getLiveData } from '@/common/requests/data-fetch/get-live-data'

  export default {
    name: 'Live',
    components: { WCatalog, CommonHeader },
    directives: {
      onDisplay,
    },
    setup() {
      const catalogData = ref(null)
      const id = ref('')
      const setLiveData = async () => {
        const { data } = await getLiveData()
        if (data) {
          catalogData.value = data?.layout?.catalog ?? {}
          id.value = data?.id ?? ''
        }
      }
      setLiveData()
      return {
        catalogData,
        id,
      }
    },
    created() {
      enableBodyScroll()
    },
    methods: {
      close() {
        if (window.history.length < 3) {
          this.$router.push('/')
        } else {
          this.$router.back()
        }
      },
      goToSchedule() {
        this.$router.push({ name: PATH_NAME_SCHEDULE })
      },
      goToReserveWatch() {
        this.$router.push({
          name: PATH_NAME_RESERVE_WATCH,
          query: {
            referer: '/live',
          },
        })
      },
    },
  }
</script>
